import React from 'react';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import { Link } from "react-router-dom";
import config from '../../config';
import MarkTopicAsReadButton from '../../components/MarkTopicAsReadButton';
import { Home } from '../Home';
import { useOverviewContext } from '../../context/OverviewContext';
import { useChecklist } from '../../context/ChecklistContext';
import ImageContent from '../../components/ImageContent';
import ImageEmailConsent from '../../assets/images/siteImg/image_emailconsent.png';
import ButtonLink from '../../components/ButtonLink';
import { FooterMobile } from "../../Layout/FooterMobile";

const ConsentProcess: React.FC = () => {
const { HOME, SCHOOL_PREP_CHECKLIST, FORM_DOCS_VIEW_ALL } = config.app.routes;
const { formattedStudentNames} = useOverviewContext();
// console.log(formattedStudentNames);

// Get checklist data & currentChecklistId from ChecklistContext
const { checklistData } = useChecklist();
const consentChecklist = checklistData.find(item => item.checklistName === "CONSENT_PROCESS");
const currentChecklistId = consentChecklist ? consentChecklist.checklistId.toString() : null;
console.log("Dynamic Checklist ID:", currentChecklistId);

return (
    <div className="home-layout">
        <div className="sidebar-wrapper">
            <Sidebar />
        </div>
        <div className="body-wrapper-content">
            <div className="row">
            <div className="col-12">
                <Header />
                <div className="main-content container-fluid">
                    <div className="row">
                        <div className="col-12">
                        <nav aria-label="breadcrumb" className="d-none d-sm-block">
                            <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to={HOME}>Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to={SCHOOL_PREP_CHECKLIST}>School Prep Checklist</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to={FORM_DOCS_VIEW_ALL}>Forms and Documents</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span>Consent Process</span>
                            </li>
                            </ol>
                        </nav>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <h1>Consent Process</h1>
                            <h4 className="pb-5">Easily indicate which activities your student may participate in.</h4>
                            
                            <div className="wp-block-k12-section container-fluid bg-color-light-gray-3">
                                <div className="wp-block-k12-content-block p-2rem">
                                    <h2>Consent Process For {formattedStudentNames}</h2>
                                    <h4><strong>Parent/legal guardian permission is required for students under 12 to participate in National K12 Zone, National K12 Communications Widget, and National K12 Chat on Mobile App.</strong></h4>
                                    <p style ={{ color: "var(--color-black)" }}>Consent can only be provided by your student’s legal guardian. If you are not your student’s legal guardian, please have them contact Customer Care to complete this process.</p>
                                    <div className="btn-primary text-center">
                                        {/* Reusable ButtonLink */}
                                        <ButtonLink
                                            urlKey="CONSENT_URL"
                                            label="Begin Process"
                                            className="external-link-btn"
                                            source="links"
                                            target="_blank"
                                        />
                                    </div>
                                </div> 
                            
                            </div>

                            <div className="wp-block-k12-section container-fluid bg-color-blue-t1-checklist mt-4">
                                <div className="wp-block-k12-content-block p-2rem">
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <h2>Not seeing your student here?</h2>
                                            <p>Parent/guardian consent is only required for students under 12 years of age.</p>
                                        </div>
                                        <div className="col-lg-4">
                                            <ImageContent
                                                imageUrl={ImageEmailConsent}
                                                imageAlt="Not seeing your student?"
                                                additionalClasses="consent-img"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                {/* Pass dynamic checklistId to MarkTopicAsReadButton */}
                {currentChecklistId && <MarkTopicAsReadButton checklistId={currentChecklistId} />}
                </div>

            </div>
            </div>
        </div>
        <FooterMobile />
    </div>
);
};
export default ConsentProcess;